const JW_IMAGE_BASE_URL = 'https://images.justwatch.com';

export default function jwImageUrl (template, profile) {
  return `${JW_IMAGE_BASE_URL}${template.replace('{profile}', profile)}`;
}
